angular.module('impactx.search').controller('CardPaneCtrl', [
    '$scope',
    '$redirect',
    '$element',
    'OneTimeDataTransporter',
    'SearchFilterStorage',
    CardPaneController
]);

function CardPaneController($scope, $redirect, $element, OneTimeDataTransporter, SearchFilterStorage) {
    var self = this;
    self.scrollPosition = 5;
    self.needsUpdate = true;

    self.$onInit = function () {
        self.containerCtrl.addPane(self);
        self.onResize = self.containerCtrl.onResize;
    };

    $scope.$watch(function () {
        return self.selected;
    }, function (newValue) {
        if (newValue) {
            self.containerCtrl.selectTab(self);
            $element.addClass('full-width');
        }
        else {
            $element.removeClass('full-width');
        }
    });

    self.showAll = function () {
        if (self.currentFilter) {
            SearchFilterStorage.setCurrentFilter(self.currentFilter);
        }
        else {
            SearchFilterStorage.setCurrentFilter(null);
        }
        if (!self.usePreSetRoute) {
            $redirect.redirectTo(null, self.showAllRoute);
        }
        else {
            OneTimeDataTransporter.setAndRedirect(self.data, self.trns, self.showAllRoute);
        }
    };
}